
import { supabase } from '@/integrations/supabase/client';
import { ProfileFormValues } from '@/lib/schemas/profileSchema';

export async function updateUserProfile(
  values: ProfileFormValues, 
  userData: any
) {
  // Update profile information in client_onboarding
  const updateData: any = {
    full_name: values.fullName,
  };
  
  if (values.phoneNumber) {
    updateData.phone = values.phoneNumber;  // Using consistent field name 'phone'
  }
  
  if (values.companyName) {
    updateData.company_name = values.companyName;
  }
  
  // Use the user's ID instead of email for the update query
  const { error: updateError } = await supabase
    .from('client_onboarding')
    .update(updateData)
    .eq('id', userData.id);
  
  if (updateError) throw updateError;
  
  // Update user metadata
  await supabase.auth.updateUser({
    data: { full_name: values.fullName }
  });
  
  // Handle password change if requested
  if (values.newPassword && values.currentPassword) {
    const { error: passwordError } = await supabase.auth.updateUser({
      password: values.newPassword
    });
    
    if (passwordError) throw passwordError;
  }
}
